import { defaultFont } from '@styles';
import Head from 'next/head';

const THEME_COLOR = '#ffffff';

const FONTS = [
  {
    href: '/fonts/boulevard-betaonebold-webfont.eot?#iefix',
    type: 'font/embedded-opentype',
  },
  {
    href: '/fonts/boulevard-betaonebold-webfont.woff2',
    type: 'font/woff2',
  },
  {
    href: '/fonts/boulevard-betaonebold-webfont.woff',
    type: 'font/woff',
  },
  {
    href: '/fonts/boulevard-betaonebold-webfont.ttf',
    type: 'font/truetype',
  },
  {
    href: '/fonts/boulevard-betaonebold-webfont.svg#boulevard_beta_1bold',
    type: 'font/svg',
  },
];

const ICONS = [
  { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: '/favicon-32x32.png',
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: '/favicon-16x16.png',
  },
  {
    rel: 'mask-icon',
    href: '/safari-pinned-tab.svg',
    color: THEME_COLOR,
  },
];

const BaseHead: React.FC = () => {
  return (
    <>
      <style jsx global>{`
        :root {
          --font-family-default: ${defaultFont.style.fontFamily};
        }
      `}</style>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, viewport-fit=cover"
        />
        {FONTS.map((props) => (
          <link
            key={props.href}
            rel="preload"
            as="font"
            crossOrigin=""
            {...props}
          />
        ))}

        {ICONS.map((linkProps) => (
          <link key={linkProps.href} {...linkProps} />
        ))}
        <link rel="icon" href="/favicon.ico" />

        <meta
          key="msapplication-TileColor"
          name="msapplication-TileColor"
          content={THEME_COLOR}
        />
        <meta key="theme-color" name="theme-color" content={THEME_COLOR} />
      </Head>
    </>
  );
};

export default BaseHead;
